import axios from 'axios'
import utils from '../utils'

/*
 * 定义请求类型
 */
const METHOD_QUERY = 'GET'
const METHOD_CREATE = 'POST'
const METHOD_SAVE = "PUT"
const METHOD_DELETE = "DELETE"

/**
 * @param method 请求类型
 * @param api 资源的路径，如['department'], 对于嵌套的资源与key相对应如: department/1/employee    
 * @param key 与资源对应，api.length - 1 <= key.length <= api.length 
 * @param param 上传的数据
 **/
let paramParse = function (method, api, param, key) {
    let url = ''
    key = key || [];
    if (key.length < api.length - 1 || key.length > api.length) {
        console.error('资源与参数不匹配');
        return false;
    }
    for (var i = 0; i < api.length; i++) {
        url += '/' + api[i];
        if (key[i]) {
            url += '/' + key[i];
        }
    }
    return new Promise((resolve, reject) => {
        // 获得本地存储的cookie user_id
        let userId = utils.getCookie('USER_ID')
        let data = {
            headers: {USER_ID: userId},
            url: url,
            method: method,
        }
        if (method === METHOD_QUERY) {
            data['params'] = param
        } else {
            data['data'] = param
        }
        axios(data).then((response) => {
            if (response.data.status === 200) {
                resolve(response.data.data)
            } else if (response.data.status === 700) { // 当前帐号信息与服务器登陆账号不一致
                if (confirm('账号已切换，是否刷新页面？')) {
                    location.reload()
                }
            } else {
                reject(response.data.msg)
            }
        }).catch((error) => {
            reject(error.message)
        })
    })
}

const Api = {
    /**
     * 查询操作
     */
    query (api, param, key) {
        return paramParse(METHOD_QUERY, [api], param, key)
    },
    /**
     * 新增操作
     */
    create (api, param) {
        return paramParse(METHOD_CREATE, [api], param)
    },
    /**
     * 修改操作
     */
    save (api, param, key) {
        return paramParse(METHOD_SAVE, [api], param, key)
    },
    /**
     * 删除操作
     */
    delete (api, param, key) {
        return paramParse(METHOD_DELETE, [api], param, key)
    },
    /**
     * api 为数组时的查询
     * @param  {[Array]} api  [请求地址]
     * @param  {[type]} param [description]
     * @param  {[type]} key  [description]
     * @return {[type]}      [description]
     */
    queryArr (api, param, key) {
        return paramParse(METHOD_QUERY, api, param, key)
    },
    /**
     * 登录
     */
    login: {
        api: 'api/login',
        submit (param) {
            return Api.create(this.api, param)
            // return paramParse(METHOD_CREATE, [this.api], param)
        }
    },
    /**
     * 账户信息
     * @type {Object}
     */
    account: {
        api: 'api/account',
        query (param) {
            return Api.query(this.api, param)
            // return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    /**
     * 页面配置初始化
     */
    config: {
        api: 'api/config',
        query (param) {
            return Api.query(this.api, param)
            // return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    /**
     * 货品信息的查找
     */
    product: {
        api: 'api/product',
        query (param) {
            return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    /**
     * 批量货品添加
     */
    batchproduct: {
        api: 'api/plproduct',
        create (param) {
            return Api.create(this.api, param)
        }
    },
    /**
     * 客户信息的查找
     */
    customer: {
        api: 'api/product',
        query (param) {
            return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    /**
     * 客户信息的查找
     */
    customers: {
        api: 'api/customer',
        query (param) {
            return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
     /**
     * 胎号信息的查找
     */
    tyre: {
        api: 'api/product',
        query (param) {
            return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
     /**
     * 病象信息的查找
     */
    symptom: {
        api: 'api/product',
        query (param) {
            return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    // 采购引用单据
    purchaseQuoteList: {
        api: 'api/purchaseQuoteList',
        query (param) {
            return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    //  采购引用单据
    purchaseQuoteInfo: {
        api: 'api/purchaseQuoteInfo',
        query (param) {
            return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    // 查询
    export: {
        api: 'api/export',
        create (param) {
            return paramParse(METHOD_CREATE, [this.api], param)
        }
    },
    // 货品品牌
    productbrand: {
        api: 'api/productbrand',
        query (param) {
            return Api.query(this.api, param)
            // return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    // 查询下载中心
    download: {
        api: 'api/download',
        query (param) {
            return Api.query(this.api, param)
            // return paramParse(METHOD_QUERY, [this.api], param)
        }
    },
    tgcQuote: {
        api: 'api/yinyong',
        query (param) {
            return Api.query(this.api, param)
        }
    },
    // 核算维度
    accountingDimension: {
        api: 'api/accountingDimension',
        query (param) {
            return Api.query(this.api, param)
        }
    },
    // 单据标记
    danjubj: {
        api: 'api/danjubj',
        query (param) {
            return Api.query(this.api, param)
        }
    },
    // 收款账户
    paymentaccount: {
        api: 'api/paymentaccount',
        query (param) {
            return Api.query(this.api, param)
        }
    },
    // bankaccount
    bankaccount: {
        api: 'api/bankaccount',
        query (param) {
            return Api.query(this.api, param)
        }
    }
}

export default Api
